function loadJQueryForCollectionList() {
  var waitForLoad = function () {
    if (typeof jQuery != "undefined") {
      if(window.matchMedia('(max-width:1144px)').matches) {
        $('.collection-list').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: false,
          dots: false,
          adaptiveHeight: false,
          arrows: false,
          responsive: [
            {
              breakpoint: 1144,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 885,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 560,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      } else if($('.collection-list').hasClass('slick-initialized')) {
        $('.collection-list').slick('unslick');
      }
    } else {
      console.log("jquery not loaded..");
      window.setTimeout(waitForLoad, 500);
    }
  };
  window.setTimeout(waitForLoad, 500);
}

loadJQueryForCollectionList();